import React, { Fragment } from 'react'
import '../HeaderHero/HeaderHero.scss'

const ContentHeaderHero = ({ data }) => {
  const { image, imageMobile, altImageText, title, text } = data
  return (
    <Fragment>
      {/* Header */}
      <section className="header-hero-caption-section">
        <div className="header-hero-caption-title-text">
          {title === 'Finally, medical supplies that arrive fast. Really fast.' ? (
            <h1 className="header-hero-caption-title">{title}</h1>
          ) : (
            <div className="header-hero-caption-title">{title}</div>
          )}
          <p className="header-hero-caption-text">{text}</p>
          {/* {props.children} */}
        </div>
        {/* <!-- FOR MOBILE USE ONLY --> */}
        <img className="header-hero-caption-image" src={image.fields.file.url} alt={altImageText} />
        {/* <!-- FOR NON-MOBILE USE ONLY --> */}
        <img
          className="header-hero-caption-image-mobile"
          src={imageMobile.fields.file.url}
          alt={altImageText}
        />
      </section>
      {/* End Header */}
    </Fragment>
  )
}

export default ContentHeaderHero
